import { Routes } from '@angular/router';

export const routes: Routes = [
    {
        path: '',
        loadChildren: () =>
            import('./features').then(({ AuthRoutes }) => AuthRoutes),
    },
    {
        path: '',
        loadChildren: () =>
            import('./features').then(
                ({ ContractListRoutes }) => ContractListRoutes
            ),
    },
    
];
